import { render, staticRenderFns } from "./DropdownMenuDetail.vue?vue&type=template&id=4fbe34fc&"
import script from "./DropdownMenuDetail.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports